import {Text, Flex, Box, Badge} from '@radix-ui/themes';
import styles from './SnippetDetail.module.scss';

interface SnippetDetailMetadataProps {
  title: string;
  tags?: string[];
  approvalNote?: string;
  editable?: boolean;
  onTitleChange?: (title: string) => void;
}

export function SnippetDetailMetadata({
  title,
  tags,
  approvalNote,
  editable = false,
  onTitleChange,
}: SnippetDetailMetadataProps) {
  return (
    <Flex direction="column" mb="5">
      <Box className={styles.title} mb="4">
        <input
          className={styles.titleInput}
          value={title}
          onChange={(event) => onTitleChange?.(event.target.value)}
          placeholder="Untitled snippet"
          readOnly={!editable}
        />
      </Box>

      {/* Tags */}
      {tags && tags.length > 0 && (
        <Flex wrap="wrap" gap="2">
          {tags.map((tag) => (
              <Badge key={tag}>
                {tag}
              </Badge>
          ))}
        </Flex>
      )}
    </Flex>
  );
}
